export const ConfigKeysEnum = {
  TwoFactorEnabled: 'two-factor-enabled',
  RegistrationRequiresApproval: 'registration-requires-approval',
  AllowAnonymousCourseView: 'allow-anonymous-course-view',
  AllowAnonymousExternalCourseView: 'allow-anonymous-external-course-view',
  AllowAnonymousEventView: 'allow-anonymous-event-view',
  CertificatesEnabled: 'certificates-enabled',
  PassingCriteriaConfigurationEnabledForAdmins:
    'passing-criteria-configuration-enabled-for-admins',
  PassingCriteriaConfigurationEnabledForInstructors:
    'passing-criteria-configuration-enabled-for-instructors',
  ClarityProjectId: 'clarity-project-id',
  ClickUpConfig: 'clickup-config',

  // -- Payment Providers --
  MoyasarCredentialConfiguration: 'moyasar-credential-configuration',
  TabbyCredentialConfiguration: 'tabby-credential-configuration',
  TamaraCredentialConfiguration: 'tamara-credential-configuration',

  // -- Messaging --
  MsegatCredentialConfiguration: 'msegat-credential-configuration',

  // -- Email Verification --
  EmailVerificationRequired: 'email-verification-required',

  // -- Translations --
  GoogleTranslationCredentials: 'google-translation-credentials',

  // -- NELC xAPI Integration --
  NelcXapiConfiguration: 'nelc-xapi-configuration',
};
export enum EnumOrganizationTerminology {
  AUTH_IMAGE = 'auth_image',
  BLENDED = 'blended',
  COURSE = 'course',
  DASHBOARD = 'dashboard',
  INSTRUCTOR = 'instructor',
  MODULE = 'module',
  STUDENT = 'student',
  LOGIN_ORGANIZATION_LOGO = 'login_organization_logo',
}
